import {
  DhlEcsDistributionCenter,
  UniUniDistributionCenter,
} from "@redotech/redo-model/fulfillments/fulfillment-carriers-and-services";
import * as z from "zod/v4";

const addressInput_ = z.object({
  street1: z.string(),
  street2: z.string().optional(),
  city: z.string(),
  state: z.string(),
  postalCode: z.string(),
  country: z.string(),
});
export type AddressInput = z.infer<typeof addressInput_>;

const dhlEcsDistributionCenterValues = Object.values(
  DhlEcsDistributionCenter,
) as [DhlEcsDistributionCenter, ...DhlEcsDistributionCenter[]];

const dhlDistanceResult_ = z.object({
  distributionCenter: z.enum(dhlEcsDistributionCenterValues),
  distanceMiles: z.number(),
  durationMinutes: z.number(),
});
export type DhlDistanceResult = z.infer<typeof dhlDistanceResult_>;

const uniuniDistributionCenterValues = Object.values(
  UniUniDistributionCenter,
) as [UniUniDistributionCenter, ...UniUniDistributionCenter[]];

const uniuniDistanceResult_ = z.object({
  distributionCenter: z.enum(uniuniDistributionCenterValues),
  distanceMiles: z.number(),
  durationMinutes: z.number(),
});
export type UniuniDistanceResult = z.infer<typeof uniuniDistanceResult_>;

export const getCarrierDistributionCenterDistances = {
  name: "getCarrierDistributionCenterDistances" as const,
  input: z.object({ address: addressInput_ }),
  output: z.object({
    dhlDistances: z.array(dhlDistanceResult_),
    uniuniDistances: z.array(uniuniDistanceResult_),
  }),
};
